export enum socialType {
  instagram,
  snapChat,
  tiktok,
}
